(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-type-quickplay/assets/javascripts/get-product-data.js') >= 0) return;  svs.modules.push('/components/content/banner-type-quickplay/assets/javascripts/get-product-data.js'); 'use strict'; 

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var quickPlayProductsDataDeprecated = [{
  product: 'keno',
  header: 'keno',
  sum: '30',
  buttonInverted: false,
  quickPlayProductId: 'keno_30',
  description: '6 rader'
}, {
  product: 'keno',
  header: 'keno',
  quickPlayProductId: 'keno_60',
  sum: '60',
  buttonInverted: false,
  description: '6 rader<br>med Kung Keno'
}, {
  product: 'keno',
  header: 'keno',
  sum: '120',
  buttonInverted: false,
  description: '12 rader<br>med Kung Keno',
  quickPlayProductId: 'keno_120'
}, {
  product: 'keno',
  header: 'keno',
  sum: '250',
  buttonInverted: false,
  quickPlayProductId: 'keno_250',
  description: '25 rader<br>med Kung Keno'
}, {
  product: 'lotto',
  header: 'lotto',
  sum: '40',
  buttonInverted: true,
  quickPlayProductId: 'lotto_40',
  description: '5 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  product: 'lotto',
  header: 'lotto',
  sum: '100',
  buttonInverted: true,
  quickPlayProductId: 'lotto_100',
  description: '15 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  product: 'lotto',
  header: 'lotto',
  sum: '200',
  buttonInverted: true,
  quickPlayProductId: 'lotto_200',
  description: '30 rader<br>Lotto 1 & 2 + Joker (20kr)'
}, {
  product: 'eurojackpot',
  header: 'eurojackpot',
  sum: '100',
  buttonInverted: true,
  quickPlayProductId: 'eurojackpot_100',
  description: '4 rader'
}, {
  product: 'eurojackpot',
  header: 'eurojackpot',
  sum: '200',
  buttonInverted: true,
  quickPlayProductId: 'eurojackpot_200',
  description: '8 rader'
}, {
  product: 'vikinglotto',
  header: 'vikinglotto',
  sum: '60',
  buttonInverted: true,
  quickPlayProductId: 'vikinglotto_60',
  description: '6 rader'
}, {
  product: 'vikinglotto',
  header: 'vikinglotto',
  sum: '120',
  buttonInverted: true,
  quickPlayProductId: 'vikinglotto_120',
  description: '12 rader'
}, {
  product: 'eurojackpot',
  header: 'eurojackpot',
  sum: '400',
  buttonInverted: true,
  quickPlayProductId: 'eurojackpot_400',
  description: '16 rader'
}, {
  product: 'rubbet',
  header: 'rubbet',
  sum: '89',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'rubbet_89',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  header: 'extratipset',
  sum: '32',
  buttonInverted: true,
  quickPlayProductId: 'extratipset_32',
  description: '32 rader'
}, {
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  header: 'extratipset',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'extratipset_64',
  description: '64 rader'
}, {
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  header: 'extratipset',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'extratipset_128',
  description: '128 rader'
}, {
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  header: 'stryktipset',
  sum: '32',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_32',
  description: '32 rader'
}, {
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  header: 'stryktipset',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_64',
  description: '64 rader'
}, {
  product: 'stryktipset',
  productName: 'Stryktipset Tips-SM',
  productId: '1',
  header: 'stryktipset',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_64_competition',
  description: 'Tips-SM, 64 rader',
  isCompetition: true
}, {
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  header: 'stryktipset',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_128',
  description: '128 rader'
}, {
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  header: 'europatipset',
  sum: '32',
  buttonInverted: true,
  quickPlayProductId: 'europatipset_32',
  description: '32 rader'
}, {
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  header: 'europatipset',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'europatipset_64',
  description: '64 rader'
}, {
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  header: 'europatipset',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'europatipset_128',
  description: '128 rader'
}, {
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  header: 'challenge',
  sum: '60',
  buttonInverted: true,
  quickPlayProductId: 'challenge_60',
  description: '12 rader'
}, {
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  header: 'challenge',
  sum: '80',
  buttonInverted: true,
  quickPlayProductId: 'challenge_80',
  description: '16 rader'
}, {
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  header: 'challenge',
  sum: '120',
  buttonInverted: true,
  quickPlayProductId: 'challenge_120',
  description: '24 rader'
}, {
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  header: 'bomben',
  sum: '40',
  buttonInverted: true,
  quickPlayProductId: 'bomben_40',
  description: '40 rader'
}, {
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  header: 'bomben',
  sum: '60',
  buttonInverted: true,
  quickPlayProductId: 'bomben_60',
  description: '60 rader'
}, {
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  header: 'bomben',
  sum: '100',
  buttonInverted: true,
  quickPlayProductId: 'bomben_100',
  description: '100 rader'
}, {
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  header: 'maltipset',
  sum: '15',
  buttonInverted: true,
  quickPlayProductId: 'maltipset_6',
  description: '6 rader'
}, {
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  header: 'maltipset',
  sum: '25',
  buttonInverted: true,
  quickPlayProductId: 'maltipset_10',
  description: '10 rader'
}, {
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  header: 'maltipset',
  sum: '35',
  buttonInverted: true,
  quickPlayProductId: 'maltipset_14',
  description: '14 rader'
}, {
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  header: 'powerplay',
  sum: '32',
  buttonInverted: true,
  quickPlayProductId: 'powerplay_32',
  description: '32 rader'
}, {
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  header: 'powerplay',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'powerplay_64',
  description: '64 rader'
}, {
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  header: 'powerplay',
  sum: '108',
  buttonInverted: true,
  quickPlayProductId: 'powerplay_108',
  description: '108 rader'
}, {
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  header: 'topptipset',
  sum: '32',
  buttonInverted: true,
  quickPlayProductId: 'topptipset_32',
  description: '32 rader'
}, {
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  header: 'topptipset',
  sum: '64',
  buttonInverted: true,
  quickPlayProductId: 'topptipset_64',
  description: '64 rader'
}, {
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  header: 'topptipset',
  sum: '108',
  buttonInverted: true,
  quickPlayProductId: 'topptipset_108',
  description: '108 rader'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '70',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_70',
  description: 'Lotto + Joker och Keno'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '140',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_140',
  description: 'Lotto + Joker och Keno'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '210',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_210',
  description: 'Lotto + Joker och Keno'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '100',
  buttonInverted: true,
  emblemOutline: true,
  test: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_100',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '170',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_170',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  product: 'lordagsgodis',
  header: 'lordagsgodis',
  sum: '240',
  buttonInverted: true,
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_240',
  description: 'Lotto + Joker, Keno och Triss'
}];
var quickPlayProductsData = [{
  type: 'tur',
  product: 'keno',
  sum: '30',
  quickPlayProductId: 'keno_30',
  description: '6 rader'
}, {
  type: 'tur',
  product: 'keno',
  quickPlayProductId: 'keno_60',
  sum: '60',
  description: '6 rader<br>med Kung Keno'
}, {
  type: 'tur',
  product: 'keno',
  sum: '120',
  description: '12 rader<br>med Kung Keno',
  quickPlayProductId: 'keno_120'
}, {
  type: 'tur',
  product: 'keno',
  sum: '250',
  quickPlayProductId: 'keno_250',
  description: '25 rader<br>med Kung Keno'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '40',
  quickPlayProductId: 'lotto_40',
  description: '5 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '100',
  quickPlayProductId: 'lotto_100',
  description: '15 rader<br>Lotto 1 & 2 + Joker (10kr)'
}, {
  type: 'tur',
  product: 'lotto',
  sum: '200',
  quickPlayProductId: 'lotto_200',
  description: '30 rader<br>Lotto 1 & 2 + Joker (20kr)'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '100',
  quickPlayProductId: 'eurojackpot_100',
  description: '4 rader'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '200',
  quickPlayProductId: 'eurojackpot_200',
  description: '8 rader'
}, {
  type: 'tur',
  product: 'vikinglotto',
  sum: '60',
  quickPlayProductId: 'vikinglotto_60',
  description: '6 rader'
}, {
  type: 'tur',
  product: 'vikinglotto',
  sum: '120',
  quickPlayProductId: 'vikinglotto_120',
  description: '12 rader'
}, {
  type: 'tur',
  product: 'eurojackpot',
  sum: '400',
  quickPlayProductId: 'eurojackpot_400',
  description: '16 rader'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '89',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_89',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '170',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_170',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'rubbet',
  sum: '370',
  emblemOutline: true,
  quickPlayProductId: 'rubbet_370',
  description: '5 färdiga miljonspel<br>Lotto + Joker x2, Eurojackpot, Keno och Vikinglotto'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '70',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_70',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '140',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_140',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '210',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_210',
  description: 'Lotto + Joker och Keno'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '100',
  emblemOutline: true,
  test: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_100',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '170',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_170',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'tur',
  product: 'lordagsgodis',
  sum: '240',
  emblemOutline: true,
  quickPlayProductId: 'lordagsgodis_tb_triss_240',
  description: 'Lotto + Joker, Keno och Triss'
}, {
  type: 'sport',
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  sum: '32',
  quickPlayProductId: 'extratipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  sum: '64',
  quickPlayProductId: 'extratipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'extratipset',
  productName: 'VM Tipset',
  productId: '2',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'extratipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '32',
  quickPlayProductId: 'stryktipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '64',
  quickPlayProductId: 'stryktipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset Tips-SM',
  productId: '1',
  sum: '64',
  quickPlayProductId: 'stryktipset_64_competition',
  description: 'Tips-SM, 64 rader',
  isCompetition: true
}, {
  type: 'sport',
  product: 'stryktipset',
  productName: 'Stryktipset',
  productId: '1',
  sum: '128',
  buttonInverted: true,
  quickPlayProductId: 'stryktipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '32',
  quickPlayProductId: 'europatipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '64',
  quickPlayProductId: 'europatipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'europatipset',
  productName: 'Europatipset',
  productId: '2',
  sum: '128',
  quickPlayProductId: 'europatipset_128',
  description: '128 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '60',
  quickPlayProductId: 'challenge_60',
  description: '12 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '80',
  quickPlayProductId: 'challenge_80',
  description: '16 rader'
}, {
  type: 'sport',
  product: 'challenge',
  productName: 'Challenge',
  productId: '45',
  sum: '120',
  quickPlayProductId: 'challenge_120',
  description: '24 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '40',
  quickPlayProductId: 'bomben_40',
  description: '40 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '60',
  quickPlayProductId: 'bomben_60',
  description: '60 rader'
}, {
  type: 'sport',
  product: 'bomben',
  productName: 'Bomben',
  productId: '7',
  sum: '100',
  quickPlayProductId: 'bomben_100',
  description: '100 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '15',
  quickPlayProductId: 'maltipset_6',
  description: '6 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '25',
  quickPlayProductId: 'maltipset_10',
  description: '10 rader'
}, {
  type: 'sport',
  product: 'maltipset',
  productName: 'Måltipset',
  productId: '8',
  sum: '35',
  quickPlayProductId: 'maltipset_14',
  description: '14 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '32',
  quickPlayProductId: 'powerplay_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '64',
  quickPlayProductId: 'powerplay_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'powerplay',
  productName: 'Powerplay',
  productId: '28',
  sum: '108',
  quickPlayProductId: 'powerplay_108',
  description: '108 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '32',
  quickPlayProductId: 'topptipset_32',
  description: '32 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '64',
  quickPlayProductId: 'topptipset_64',
  description: '64 rader'
}, {
  type: 'sport',
  product: 'topptipset',
  productName: 'Topptipset',
  productId: '25',
  sum: '108',
  quickPlayProductId: 'topptipset_108',
  description: '108 rader'
}]; 

function getProductData(banner) {
  var useDeprecated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !svs.core.detect.feature('ft-quickplay-v2');
  var quickPlayProducts = useDeprecated ? quickPlayProductsDataDeprecated : quickPlayProductsData;
  return Object.assign({}, banner, quickPlayProducts.filter(function (product) {
    return product.quickPlayProductId === banner.quickPlayProductId;
  })[0]);
}

if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
  module.exports = getProductData;
} else {
  svs.content.bannerTypeQuickplay.getProductData = getProductData;
}
 })(window);